// umlaut-check: skip — "ZustaendigkeitStatusTiles" ist ein Komponenten-
// /Dateiname (technischer Bezeichner), bleibt ASCII.

import React from "react";
import {Card, OverlayTrigger, Tooltip} from "react-bootstrap";
import {formatMenge} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

// Befund Sichtprüfung 3 #S2: das Label dieser einen Kachel kommt aus
// App\Services\Cosmos\LieferfaehigkeitQuery::kacheln() mit geraden
// Anführungszeichen ("zu spät") - hier auf deutsche Anführungszeichen
// korrigiert, ohne die Backend-Antwort anzufassen.
const LABEL_UEBERSCHREIBUNG = {
    zu_spaet: 'Warnung „zu spät“',
};

/**
 * Kennzahlen-Kacheln am Kopf der Lieferfähigkeit (PLAN.md Abschnitt 5) -
 * jede Kachel filtert für sich allein (Rückmeldung T4: "wenn ich eine
 * dieser Karten anklicke, werden alle vier aktiv - das sieht mir noch nach
 * einem Fehler aus"). `aktiveKachel` trägt den Schlüssel HÖCHSTENS einer
 * Kachel; ein erneuter Klick auf die bereits aktive Kachel hebt die
 * Filterung wieder auf. Kacheln mit Anzahl 0 verschwinden vollständig
 * (Hausregel leere Bausteine).
 */
export default function LieferfaehigkeitKacheln({kacheln, aktiveKachel, onKlick}) {
    const sichtbare = (kacheln || []).filter((k) => Number(k.anzahl) > 0);

    if (sichtbare.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap gap-2 mb-3">
            {sichtbare.map((k) => {
                const aktiv = k.schluessel === aktiveKachel;
                return (
                    <OverlayTrigger
                        flip
                        popperConfig={TOOLTIP_POPPER_CONFIG}
                        key={k.schluessel}
                        placement="top"
                        overlay={<Tooltip id={`cosmos-kachel-${k.schluessel}`}>{k.hilfe}</Tooltip>}
                    >
                        <button
                            type="button"
                            onClick={() => onKlick(k.schluessel)}
                            className="btn p-0 border-0 bg-transparent text-start"
                            aria-pressed={aktiv}
                        >
                            <Card className={`shadow-sm h-100 ${aktiv ? "border-primary border-2" : ""}`} style={{minWidth: 190}}>
                                <Card.Body className="py-2 px-3">
                                    <div className="small text-muted mb-1">{LABEL_UEBERSCHREIBUNG[k.schluessel] || k.label}</div>
                                    <div className="fw-semibold fs-5">{formatMenge(k.anzahl)}</div>
                                </Card.Body>
                            </Card>
                        </button>
                    </OverlayTrigger>
                );
            })}
        </div>
    );
}
